module.exports = __webpack_public_path__ + "mssql-logo.png?bb9d3f5e8e95d918f4463dcaee6957c3";